export const MONTHLY = 1
export const THREE_MONTHS = 3
export const SIX_MONTHS = 6
export const ANNUALLY = 12

export type BillingPeriodType = typeof MONTHLY | typeof ANNUALLY

export type SelectableBillingPeriodTypes = typeof MONTHLY | typeof ANNUALLY

export type PossibleBillingPeriodTypes =
  | typeof MONTHLY
  | typeof THREE_MONTHS
  | typeof SIX_MONTHS
  | typeof ANNUALLY
